import type { Tracker } from '@archipro-website/tracker';

export const trackBreadcrumbClick = (
    tracker: Tracker,
    breadcrumbURL: string,
) => {
    tracker.log('BreadcrumbClick', {
        url: new URL(window.location.href),
        targetTracker: ['archiproTracker', 'archiproTrackerV2'],
        data: {
            ExtraData: breadcrumbURL,
        },
    });
};
